<template>
  <div>
    <p>
      Renew successful<br />
      Your browser should be redirected soon...
    </p>
  </div>
</template>

<script>
import AuthenticationService from "../services/AuthenticationService.js";
import Toaster from "../mixins/toaster.js";

export default {
  name: "RenewCallback",
  mixins: [Toaster],
  data() {
    return {};
  },
  async created() {
    try {
      await AuthenticationService.signinSilentCallback();
      this.$router.push({ name: "home" });
    } catch (e) {
      this.toast("danger", "Autenticazione", e);
    }
  },
};
</script>
